import { useLocation } from 'react-router-dom';

// A page opened in a new tab (or reached via a direct URL / bookmark) starts a
// fresh browser session with a single history entry, so `navigate(-1)` has
// nowhere to go. `window.history.length > 1` is the only reliable signal that a
// previous in-tab page exists to return to. `document.referrer` is not: a
// same-origin link opened in a new tab still sets it even though there is no
// history to go back to.
export const useCanGoBack = (): boolean => {
  useLocation();

  return window.history.length > 1;
};
